import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import APIKit from "../../Middleware/axiosConfig";

// API End Points
import { API_END_POINTS } from "../../Middleware/apiEndpoints";

//utils
import { notifyError } from "Services/Utils/toastNotification";

// API calls
export const getContactRequestList = createAsyncThunk(
  "getContactRequestList",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getContactRequestList}${data?.page}&limit=${data?.limit}&search=${data?.search}&sortColumn=${data?.order_by}&sort=${data?.sort_by}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const getContactDetailsRequest = createAsyncThunk(
  "getContactDetailsRequest",
  async ({ data, callBack }) => {
    // api hit
    const response = await APIKit().get(
      `${API_END_POINTS.getContactDetailsRequest}${data?.contactId}`
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const postReplyToUserRequest = createAsyncThunk(
  "postReplyToUserRequest",
  async ({ contactId, data, callBack }) => {
    // api hit
    const response = await APIKit().post(
      `${API_END_POINTS.postReplyToUserRequest}${contactId}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const closeUserChatRequest = createAsyncThunk(
  "closeUserChatRequest",
  async ({ contactId, data, callBack }) => {
    // api hit
    const response = await APIKit().put(
      `${API_END_POINTS.closeUserChatRequest}${contactId}`,
      data
    );
    if (response?.status === 200) {
      callBack(response?.data);
    } else {
      notifyError(response?.data?.message);
    }
    return response?.data;
  }
);

export const contactManagementSlice = createSlice({
  name: "contactManagement",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getContactRequestList.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getContactRequestList.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getContactRequestList.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    builder
      .addCase(getContactDetailsRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(getContactDetailsRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(getContactDetailsRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    builder
      .addCase(postReplyToUserRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(postReplyToUserRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(postReplyToUserRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });

    builder
      .addCase(closeUserChatRequest.pending, (state) => {
        state.isLoading = "loading";
      })
      .addCase(closeUserChatRequest.fulfilled, (state, action) => {
        state.isLoading = "succeeded";
      })
      .addCase(closeUserChatRequest.rejected, (state, action) => {
        state.isLoading = "failed";
      });
  },
});

export default contactManagementSlice.reducer;
